/**
 * YesHuman landing type roles.
 * Inter = structure (headings, labels, UI, short supporting copy).
 * PT Serif = editorial reading only (ledes, pull quotes, purpose).
 *
 * Scale (CSS vars on `.yeshuman-marketing-shell`):
 * label 12 · support 15 · editorial 20 · section clamp · hero clamp · pull clamp
 */

/** Section labels, figure keys — small caps tracking (sans) */
export const yeshumanAnn = 'yeshuman-label text-[var(--marketing-text)]'

/** Dim labels — AA on paper via `--yeshuman-ink-subtle` */
export const yeshumanAnnDim = 'text-[var(--yeshuman-ink-subtle,var(--marketing-muted))]'

/** Primary editorial ledes — PT Serif; measure via `yeshumanMeasure` at call sites */
export const yeshumanEditorial = 'yeshuman-editorial text-[var(--marketing-muted)]'

/** Editorial at ink — breadth / pull blocks */
export const yeshumanEditorialInk = 'yeshuman-editorial text-[var(--marketing-text)]'

/** Short supporting copy under terms — sans */
export const yeshumanEditorialSm = 'yeshuman-support text-[var(--marketing-muted)]'

/** Centred italic statement band — PT Serif display */
export const yeshumanEditorialDisplay = 'yeshuman-editorial-display text-[var(--marketing-text)]'

/** Footer purpose / long italic — same size as editorial lede */
export const yeshumanSerifItalic =
  'yeshuman-serif yeshuman-editorial italic text-[var(--marketing-text)]'

/** Section headings — Inter; size from shell scale */
export const yeshumanDisplayHeading =
  'yeshuman-sans yeshuman-display font-medium leading-[1.12] tracking-[-0.02em] text-balance text-[var(--marketing-text)]'

export const yeshumanHeroHeading =
  'yeshuman-sans yeshuman-hero relative max-w-[11em] font-medium leading-[1.05] tracking-[-0.025em] text-balance text-[var(--marketing-text)]'

/** Term / subsection titles */
export const yeshumanEditorialTerm =
  'yeshuman-sans text-base font-medium leading-snug tracking-[-0.01em] text-[var(--marketing-text)]'

/** Comfortable reading measure (~60–75 characters) */
export const yeshumanMeasure = 'max-w-[65ch]'

/** Narrower measure for stage / proof support */
export const yeshumanMeasureNarrow = 'max-w-[42ch]'

/** Stage / figure numbers */
export const yeshumanTabular = 'tabular-nums'

/** UI controls */
export const yeshumanUiSans = 'yeshuman-sans'
